import React from "react";
import classNames from "classnames";
import classes from "../styles.module.scss";

const SplitPagesContainer = ({
    vertical = false, // horizontal by default
    children
}) => {
    return (
        <div className={classNames(classes.dualPageContainer, { [classes.vertical]: vertical })}>
            {children}
        </div>
    );
}

export default SplitPagesContainer;